import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useLocation } from 'react-router';
import { Panel } from '../../../components/idsk';
import { usePageTitle } from '../../../layout/usePageTitle';
import { useWizard } from './WizardContext';

export function WizardConfirmation() {
  const { t } = useTranslation();
  const created = useLocation().state as { id: string; number: string; name: string } | null;
  const { reset } = useWizard();
  usePageTitle([t('wizard.done.title'), t('wizard.title')]);
  useEffect(() => {
    if (created) reset();
  }, [created, reset]);
  if (!created) return <Navigate to="/inspekcie" replace />;
  return (
    <div className="govuk-grid-row">
      <div className="govuk-grid-column-two-thirds">
        <Panel title={t('wizard.done.title')}>
          {t('wizard.done.number')}
          <br />
          <strong data-testid="created-number">{created.number}</strong>
        </Panel>
        <p className="govuk-body">{t('wizard.done.body', { name: created.name })}</p>
        <p className="govuk-body">
          <Link className="govuk-link" to={`/inspekcie/${created.id}`}>
            {t('wizard.done.detail', { number: created.number })}
          </Link>
        </p>
        <p className="govuk-body">
          <Link className="govuk-link" to="/inspekcie/nova">
            {t('wizard.done.another')}
          </Link>
        </p>
      </div>
    </div>
  );
}
